import React, { useEffect } from "react";
import "../css/cameraStream.css";
import { Common } from "./Canvas";
import { animateSelectedTool } from "../js/handlers";
import capture from "../images/capture.png";
import Utility from "../js/utility";

export default function CameraStream() {
  useEffect(() => {
    let camera_button = document.querySelector("#camera");
    let camera_stream = document.querySelector(".camera_stream_wrapper");
    let camera_video = document.querySelector(".camera_video");
    let take_picture = document.querySelector(".take_picture_button");

    camera_button.addEventListener("click", showCameraStream);
    take_picture.addEventListener("click", takePicture);

    let stream = null;

    function showCameraStream() {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: "user" } })
        .then((mediaStream) => {
          if (Common.selected_tool_id !== "6") {
            Common.previous_selected_tool_id = Common.selected_tool_id;
          }

          Common.selected_tool_id = "8";

          Utility.hideMenus();
          animateSelectedTool();

          stream = mediaStream;
          camera_video.srcObject = mediaStream;
          camera_video.play();

          camera_stream.classList.add("show_camera_stream");
        })
        .catch((error) => {
          console.log("Unable to find camera: " + error);
        });

      // ------- TESTING --------
      // * note: also delete below from "let track = ..." to "stream = null" and un-comment 'src' from <video> html;
      //
      // if (Common.selected_tool_id !== "6") {
      //   Common.previous_selected_tool_id = Common.selected_tool_id;
      // }
      // Common.selected_tool_id = "8";
      // animateSelectedTool();

      // camera_video.play();

      // camera_stream.classList.add("show_camera_stream");
    }

    function takePicture() {
      Utility.hideMenus();

      let canvas_dummy = document.createElement("canvas");
      let ctx_dummy = canvas_dummy.getContext("2d");
      let imageContainer = document.querySelector(".chosenImageContainer");

      canvas_dummy.width = camera_video.clientWidth;
      canvas_dummy.height = camera_video.clientHeight;

      ctx_dummy.drawImage(
        camera_video,
        0,
        0,
        canvas_dummy.width,
        canvas_dummy.height
      );

      Common.newImage.src = canvas_dummy.toDataURL("image/png");
      let rect = document.querySelector(".rect");
      rect.style.backgroundImage = `url(${Common.newImage.src})`;

      let track = stream.getTracks()[0];

      track.stop();
      camera_video.load();
      stream = null;

      camera_stream.classList.remove("show_camera_stream");
      imageContainer.classList.add("showImageContainer");

      Common.selected_tool_id = Common.previous_selected_tool_id;
      animateSelectedTool();
    }

    return () => {
      camera_button.removeEventListener("click", showCameraStream);
      take_picture.removeEventListener("click", takePicture);
    };
  });

  return (
    <div className="camera_stream_wrapper">
      <div className="camera_stream">
        <video
          className="camera_video"
          crossOrigin="anonymous"
          // src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
        ></video>
        <button className="take_picture_button">
          <img src={capture} alt="" />
        </button>
      </div>
    </div>
  );
}
